// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2owtx","imageUploader":"EGiftCard_imageUploader__3fmNe"};